// src/stone/icons/ContactlessCard.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ContactlessCard = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M3 3.75A1.25 1.25 0 0 0 1.75 5v14A1.25 1.25 0 0 0 3 20.25h18A1.25 1.25 0 0 0 22.25 19V5A1.25 1.25 0 0 0 21 3.75zm-1.945-.695A2.75 2.75 0 0 1 3 2.25h18A2.75 2.75 0 0 1 23.75 5v14A2.75 2.75 0 0 1 21 21.75H3A2.75 2.75 0 0 1 .25 19V5c0-.73.29-1.429.805-1.945" }),
      /* @__PURE__ */ jsx("path", { d: "M4.25 16.25h8.5v1.5h-8.5zM15.25 16.25h4.5v1.5h-4.5zM17.444 5.946l.585.469a4.595 4.595 0 0 1 0 7.17l-.585.47-.938-1.171.585-.47a3.095 3.095 0 0 0 0-4.829l-.585-.469zM14 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" })
    ]
  }
);
var ContactlessCard_default = ContactlessCard;

export {
  ContactlessCard_default
};
